import { FC } from "react";
import { Link } from "react-router-dom";
import HouseIconSVG from "../../resources/svg/HouseIconSVG";
import DocumentsIconSVG from "../../resources/svg/DocumentsIconSVG";
import UserIconSVG from "../../resources/svg/UserIconSVG";
import AccomplishedIconSVG from "../../resources/svg/AccomplishedIconSVG";
import CreateIconSVG from "../../resources/svg/CreateIconSVG";
import SendIconSVG from "../../resources/svg/SendIconSVG";
import SubscribeIconSVG from "../../resources/svg/SubscribeIconSVG";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";

const DesktopHeaderBurgerMenuContents: FC = () => {
    const { upTo800, moreOrEqual800 } = useScreenSize();
    const { t } = useTranslation();

    return (
        <>
            {upTo800 && (
                <>
                    <Link
                        to="/"
                        className="flex items-center cursor-pointer w-full pb-4 border-b border-b-textFaded group"
                    >
                        <HouseIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                        <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                            {t("common.main")}
                        </span>
                    </Link>
                    <Link
                        to="/catalog"
                        className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
                    >
                        <DocumentsIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                        <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                            {t("common.catalog")}
                        </span>
                    </Link>
                </>
            )}
            <Link
                to="/profile"
                className={`flex items-center cursor-pointer w-full ${
                    moreOrEqual800 ? "mt-0" : "mt-[22px] dmax2:mt-[20px]"
                } pb-4 border-b border-b-textFaded group`}
            >
                <UserIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.myProfile")}
                </span>
            </Link>
            <Link
                to="/completed-orders"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <AccomplishedIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.completedOrders")}
                </span>
            </Link>
            <Link
                to={`/created-orders`}
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <CreateIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.createdOrders")}
                </span>
            </Link>
            <Link
                to="/applications"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <SendIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.myRequests")}
                </span>
            </Link>
            <Link
                to="/subscription"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <SubscribeIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.subscription")}
                </span>
            </Link>
        </>
    );
};

export default DesktopHeaderBurgerMenuContents;
